const mandatoryFields = ['first_name', 'last_name', 'email', 'username', 'phone'];

export default mandatoryFields;
